import {ordersServicesPath
} from "../../Constants";
import axios from "axios";

const restUrl = ordersServicesPath + '/organizations/margin-customers'

export default class MarginCustomerController {
    static async getAll(materialOrganizationOptionId) {
        return axios.get(restUrl + "/by-material-organization-option?materialOrganizationOptionId=" + materialOrganizationOptionId);
    }

    static async update(data, id) {
        return await axios.put(restUrl + "/" + id,
            JSON.stringify({margin: data.margin, current: data.current}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async create(data, materialOrganizationOptionId) {
        return await axios.post(restUrl + "?materialOrganizationOptionId=" + materialOrganizationOptionId + "&customerId=" + data.customerId + "&customerName=" + data.customerName,
            JSON.stringify({margin: data.margin, current: data.current}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async byIds(data, ids) {
        const idsQuery = ids.reduce((acc, el) => (`${acc}&ids=${el}`), "")
        return await axios.post(restUrl + "/by-ids?customerId=" + data.customerId + "&customerName=" + data.customerName + idsQuery,
            JSON.stringify({margin: data.margin, current: data.current}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}